import React from 'react';
import DesktopApp from './DesktopApp';
import MobileApp from './mobile/MobileApp';
import './App.css';

const isMobileClient = () => {
  try {
    const w = window.innerWidth || 0;
    if (w > 0 && w <= 768) return true;
    const ua = String(window.navigator?.userAgent || '').toLowerCase();
    return /iphone|ipod|ipad|android|mobile/.test(ua);
  } catch (e) {
    return false;
  }
};

function App() {
  const mobile = isMobileClient();
  return mobile ? <MobileApp /> : <DesktopApp />;
}

export default App;
